// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { OrderTypeBase } from './OrderTypeBase';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { CareOrderEdit } from '../order-edit/CareOrderEdit';
import { ModifyCareOrder } from '../order-modify/ModifyCareOrder';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
export class CareOrderType extends OrderTypeBase {
    constructor() {
        super(CareOrderEdit, ModifyCareOrder);
    }
    id() {
        return OrderType.Care;
    }
    IsSupported(params) {
        const allowedByRule = this.checkRuleForAccount(params.account, RulesSet.FUNCTION_CARE_ORDERS, params.instrument);
        return allowedByRule && super.IsSupported(params);
    }
}
